/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/jsx-no-undef */
import { FC, ReactNode } from 'react';

import { IconType } from 'react-icons';

import Link from 'next/link';

import { TColorProp, useTheme } from 'styled-components';

import { getThemeColor } from '~/common/utils/get-theme-color';

import { CustomArrow, Option } from './styles';
import { Typography } from '../Typography';
import { Icon } from '../Icons';
import { IBadgeProps } from '../Badge/types';
import { Badge } from '../Badge';

interface IGenericMenuItemProps {
  index: number;
  id?: string;
  selected: boolean;
  icon?: string;
  customIcon?: IconType;
  imageUrl?: string;
  title: string;
  href?: string;
  hoverColor?: TColorProp;
  withoutHoverCursor?: boolean;
  transparentBackground?: boolean;
  iconColor?: TColorProp;
  withoutIconHighligh?: boolean;
  paddingLeft?: string;
  arrowState?: 'top' | 'bottom';
  as?: string;
  compact?: boolean;
  badge?: IBadgeProps;
  renderContent?: (id: string) => ReactNode;
  onClick?: () => void;
}
export const GenericMenuItem: FC<IGenericMenuItemProps> = ({
  index,
  id,
  selected,
  icon,
  customIcon,
  title,
  href,
  arrowState,
  paddingLeft,
  as = 'li',
  renderContent,
  hoverColor = 'neutral.900',
  iconColor = 'neutral.400',
  transparentBackground = false,
  withoutIconHighligh = false,
  compact = false,
  withoutHoverCursor = false,
  imageUrl,
  badge,
  onClick,
}) => {
  const theme = useTheme();
  const resolvedIconColor =
    selected && !withoutIconHighligh
      ? theme.green[500]
      : getThemeColor(theme, iconColor);
  const CustomIcon = customIcon;

  const Element = (
    <Option
      id={id}
      hoverColor={hoverColor}
      withoutHoverCursor={withoutHoverCursor}
      as={as}
      paddingLeft={paddingLeft}
      key={String(index)}
      current={selected}
      onClick={onClick}
      transparentBackground={transparentBackground}
    >
      {renderContent ? (
        <>{renderContent(id)}</>
      ) : (
        <>
          {CustomIcon ? (
            <CustomIcon color={resolvedIconColor} size={20} />
          ) : (
            icon && <Icon type={icon} color={resolvedIconColor} size={20} />
          )}

          {imageUrl && (
            <img
              src={imageUrl}
              alt={title}
              style={{
                width: '20px',
                height: '20px',
                borderRadius: '50%',
              }}
            />
          )}

          {!compact && (
            <>
              <Typography.Label
                size="small"
                color={selected ? 'neutral.50' : 'neutral.400'}
              >
                {title}
              </Typography.Label>

              {badge && (
                <div style={{ marginLeft: 'auto' }}>
                  <Badge {...badge} />
                </div>
              )}

              {arrowState && (
                <div style={{ marginLeft: 'auto' }}>
                  <CustomArrow
                    type="arrow-right-s-line"
                    to={arrowState}
                    color={theme.neutral[400]}
                    size={20}
                  />
                </div>
              )}
            </>
          )}
        </>
      )}
    </Option>
  );

  return href ? (
    <Link href={href} passHref>
      {Element}
    </Link>
  ) : (
    Element
  );
};
